import React from 'react'
import { Check, X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface GuideTipProps {
  type: 'do' | 'dont'
  children: React.ReactNode
}

export default function GuideTip({ type, children }: GuideTipProps) {
  const isDo = type === 'do'
  return (
    <div
      className={cn(
        'flex gap-3 rounded-lg border-l-[3px] px-4 py-3',
        isDo
          ? 'border-l-emerald-500 bg-emerald-50/50'
          : 'border-l-rose-500 bg-rose-50/50'
      )}
    >
      <div className={cn(
        'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full',
        isDo ? 'bg-emerald-100 text-emerald-600' : 'bg-rose-100 text-rose-600'
      )}>
        {isDo ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
      </div>
      <div className="text-sm leading-relaxed text-muted-foreground">{children}</div>
    </div>
  )
}
